import { ref, isRef } from '@nuxtjs/composition-api';
export function wrap(o) {
  return isRef(o) ? o : ref(o); // NOTE in v3 this is not necessary
}
export const NO_OP = () => {};
export const isClient = typeof window !== 'undefined';

export const generateUniqueId = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
